import { LoaderTraceLogo } from '@stratumn/atomic';

import graphql from 'babel-plugin-relay/macro';
import { ROUTE_BOTS } from 'constant/routes';
import { KEYS_ORDER_BY } from 'constant/types';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import { QueryRenderer } from 'react-relay';
import { generatePath, Redirect, withRouter } from 'react-router-dom';
import { toast } from 'sonner';
import { withGqlClient, withSpecificError, withUser } from 'wrappers';

import Bot from './bot';

const query = graphql`
  query botRootQuery($botRowId: BigInt!, $orderKeysBy: [KeysOrderBy!]) {
    botByRowId(rowId: $botRowId) {
      ...bot_bot
    }
  }
`;

export const Renderer = withSpecificError(
  ({ error, props: data, match: { params } }) => {
    if (!(data || error)) return <LoaderTraceLogo />;

    let bot;

    if (data) bot = data.botByRowId;

    if (error || !bot) {
      toast.error(`the bot with the id ${params.id} does not exist.`);
      return (
        <Redirect to={generatePath(ROUTE_BOTS, { orgId: params.orgId })} />
      );
    }

    return <Bot bot={bot} />;
  }
);

Renderer.propTypes = {
  error: PropType.object,
  props: PropType.object
};

Renderer.defaultProps = {
  error: undefined,
  props: undefined
};

export const BotRoot = props => {
  const { environment, botRowId } = props;

  const variables = {};
  variables.botRowId = botRowId;
  variables.orderKeysBy = KEYS_ORDER_BY;

  // We need to make sure that the location props are passed to child components correctly.
  // https://github.com/ReactTraining/react-router/blob/v4.2.2/packages/react-router/docs/guides/blocked-updates.md
  const RendererWithRouter = withRouter(Renderer);

  return (
    <QueryRenderer
      environment={environment}
      query={query}
      render={RendererWithRouter}
      variables={variables}
    />
  );
};

BotRoot.propTypes = {
  environment: PropType.object.isRequired,
  botRowId: PropType.string.isRequired
};

BotRoot.defaultProps = {};

export default compose(withUser, withGqlClient)(BotRoot);
